module.exports = __webpack_public_path__ + "static/media/ctbc-4-designSystem.c6561480.png";